import rootReducer from "../reducers/index";
import { createStore, applyMiddleware, compose } from "redux";
import reduxThunk from "redux-thunk";
// const store = createStore(rootReducer);

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  persistedReducer,
  composeEnhancer(applyMiddleware(reduxThunk))
);
let persistor = persistStore(store);

export { store, persistor };

// comment below code before deploying

// import rootReducer from '../reducers/index';
// import { createStore, applyMiddleware, compose } from 'redux';
// import reduxThunk from 'redux-thunk';
// // const store = createStore(rootReducer);

// const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const store = createStore(rootReducer, composeEnhancer(applyMiddleware(reduxThunk)));

// export default store;
